import { render, staticRenderFns } from "./xeWorkflowDetail.vue?vue&type=template&id=6e382e24"
import script from "./xeWorkflowDetail.vue?vue&type=script&lang=js"
export * from "./xeWorkflowDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports